<div class="jw-modal request-popup-modal">
    <div class="jw-modal-body" id="modalPdp">
        <ng-content></ng-content>
    </div>
</div>
<div class="jw-modal-background"></div>
